// Citirex Insights — placeholder editorial content
export const POSTS = [
  {
    slug: "stop-buying-leads-start-buying-bind-rate",
    title: "Stop buying leads. Start buying bind rate.",
    excerpt:
      "Volume is a vanity metric. The only number that matters to a carrier is what closes — and most agencies are still selling the wrong KPI.",
    category: "Strategy",
    author: "Margaret Chen",
    date: "2026-11-12",
    readTime: "6 min read",
    cover:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71",
    body: [
      "For fifteen years the lead generation industry has sold itself on volume. More records, more calls, more posts per minute. The problem is that growth teams don't get paid on records — they get paid on bind. And bind rate is mostly upstream of the lead itself.",
      "When we onboard a new carrier partner the first thing we ask for isn't a CPL target. It's an appetite document. We want the underwriting truth: what state, what age, what credit tier, what risk factors are auto-knockouts. The funnel gets built against that — not against generic 'insurance shoppers'.",
      "That sounds obvious. It isn't how most of the industry works. Aggregators are economically incentivized to push every record they can monetize, because their margin is the spread between source and resale. Carriers absorb the cost of records they can't write.",
      "The shift is to price on outcome. Data, calls, transfers and appointments are all priced to a target bind, not to a target CPL. Misses are absorbed by the vendor, not the carrier. Vendors who can't deliver against bind targets get replaced — fast.",
      "If your acquisition team can't tell you their bind rate by lead source, by week, by ZIP — you're not buying media. You're buying lottery tickets.",
    ],
  },
  {
    slug: "tcpa-2026-what-changed",
    title: "TCPA in 2026: what actually changed, and what it means for buyers.",
    excerpt:
      "A practical breakdown of the one-to-one consent rule, what survives, and how it reshapes lead resale economics.",
    category: "Compliance",
    author: "David Park",
    date: "2026-10-28",
    readTime: "8 min read",
    cover:
      "https://images.pexels.com/photos/6476256/pexels-photo-6476256.jpeg",
    body: [
      "The one-to-one consent rule changes the economics of shared leads. Where vendors used to capture a single TCPA consent and resell a record to multiple buyers under a generic 'marketing partners' disclosure, buyers now need to be specifically identified at the point of consent.",
      "For aggregators, that compresses the spread. A record that could previously be sold three ways now generally requires three separate consent capture events — or a buyer-identified flow at the time of submission.",
      "For carriers and contractors, it's an unlock. Exclusive data is cheaper to defend than ever. Shared data with buyer-identified consent is auditable in a way it never was before. And anyone who built their stack on broad-disclosure shared leads is going to feel real pressure.",
      "We've been building consent capture this way for three years. It's not a pivot — it's just compliance hygiene catching up with the market.",
    ],
  },
  {
    slug: "live-transfers-vs-appointment-set",
    title: "Live transfers vs. appointment-set: when each one actually wins.",
    excerpt:
      "Two formats, two completely different sales orgs. A field guide for which to buy when.",
    category: "Playbook",
    author: "Sara Iyer",
    date: "2026-10-05",
    readTime: "5 min read",
    cover:
      "https://images.pexels.com/photos/16631149/pexels-photo-16631149.jpeg",
    body: [
      "Live transfers and appointment-set are not interchangeable lead products. They're matched to different sales orgs and different close motions.",
      "Live transfers win when you have a licensed call center that can close in a single sitting — Medicare, final expense, life telesales, ACA. Inbound momentum carries the buyer; latency kills the deal. If your agents spend 30 minutes between calls, you're burning transfers.",
      "Appointment-set wins when the buyer needs to see something — a roof, a system design, a kitchen. Solar, roofing, HVAC, windows. The setter's job is to qualify, schedule and confirm. The close happens at the home, not the phone.",
      "Mixing them is fine. Selling them like they're the same is how growth teams lose budget.",
    ],
  },
];

export const POST_BY_SLUG = Object.fromEntries(POSTS.map((p) => [p.slug, p]));
